import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import Chatroom from '../Chatroom/Chatroom.js';
import OfferBox from '../OfferBox/OfferBox';
import './App.css';
import Grid from '@material-ui/core/Grid';
import { withRouter} from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import leftIcon from '../../images/leftPointer.svg'
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

const styles = theme => ({
    headerContainer: {
        height: '100px',
        backgroundColor: '#6C0E21',
        verticalAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            minHeight: '80px',
            padding: '10px 0'
        }
    },
    backButton: {
        textAlign: 'left',
        color: 'white',
        marginLeft: '30px',
        fontWeight: 'bold',
        fontSize: '16px',
        float: 'left',
        height: '100%',
        verticalAlign: 'middle',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            fontSize: '14px'
        }
    },
    backIcon: {
        width: '13%',
        marginRight: '10px',
        [theme.breakpoints.down('sm')]: {
            width: '13%'
        }
    },
    title: {
        marginTop: '-25px',
        color: 'white',
        textAlign: 'center',
        fontWeight: 'bolder',
        wordWrap: 'breakWord',
        whiteSpace: 'normal',
        fontSize: '17px',
        fontFamily: 'Times New Roman Georgia',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            marginTop: '-15px',
            padding: '0 10px'
        }
    },
    subtitle: {
        color: '#a52423',
        fontWeight: 'bolder',
        wordWrap: 'breakWord',
        whiteSpace: 'normal',
        fontSize: '17px',
        fontFamily: 'Times New Roman Georgia',
        padding: '0 20px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
            padding: '0 15px'
        }
    },
    contentWrapper: {
        maxWidth: '1200px',
        width: '100%',
        margin: '0 auto',
        padding: '0 20px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 10px'
        }
    }
});

class Settlement extends Component {
    
    componentDidMount(){
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'))
      }

    render(){
        
        const { classes } = this.props;
        // const state = this.state;
        // console.log('CaseInformation classes: '+JSON.stringify(classes));
        // if(this.props.loadingCaseInfo){
        //     console.log('AN loadingCaseInfo')
        //     return(
        //         <CircularProgress size={50} thickness={3}/>
        //     );
        // }
        // else{ 
            return(
                <div className="App" style={{ width: '100%', height:'100%', marginTop:'0px' }}>

                <Grid
                container
                direction="row"
                justifyContent="center"
                alignContent="center"
                >
                     <Grid
                        item
                        spacing={8}
                        md={12}
                        lg={12}
                        sm={12}
                        xs={12}
                        style={{marginBottom:'10px'}}
                        >
                        <div className={classes.headerContainer}>
                        <Grid
                            container
                            direction="column"
                            spacing={1}
                            >
                                <Grid
                                    item
                                    md={2}
                                    lg={2}
                                    sm={12}
                                    xs={12}
                                    style={{marginTop:'30px'}}
                                    >
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} className={classes.backButton}>
                                    <img className={classes.backIcon} src={leftIcon} alt="back"></img>{this.context.t("Back")}</Button>
                                </Grid>
                                <Grid
                                    item
                                    md={12}
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                    >
                                    <h3 className={classes.title}>
                                    {this.context.t('Settlement Chatroom')}
                                </h3>
                                </Grid>
                            </Grid>
                        </div>
                        
                    </Grid>
                    <div className={classes.contentWrapper}>
                        <h3 className={classes.subtitle}>
                        {this.context.t('The Parties can negotiate for settlement in this page ')}<br></br> 
                        { localStorage.getItem('language') == 'en' ? this.context.t('and the Arbitrator cannot read the contents') :''}.
                        </h3>
                        
                        <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                        spacing={2}
                        style={{marginTop: '20px'}}
                        >
                            <Grid
                            item
                            md={12}
                            lg={12}
                            sm={12}
                            xs={12}
                            style={{display: 'flex', justifyContent: 'center'}}
                            >
                                <div style={{width: '100%', maxWidth: '600px'}}>
                                    <OfferBox />
                                </div>
                            </Grid>
                            <Grid
                            item
                            md={12}
                            lg={12}
                            sm={12}
                            xs={12}
                            style={{display: 'flex', justifyContent: 'center'}}
                            >
                                <div style={{width: '100%', maxWidth: '1000px'}}>
                                    <Chatroom />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                </div>
            );
        // }
    }

}

const mapStateToProps = (state) => {
    // console.log('mapStateToProps: state: '+JSON.stringify(state));
    return {
        //error: state.caseInfo.error,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
        loadingCaseInfo: state.caseInfo.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
    }
}

Settlement.contextTypes = {
    t: PropTypes.func
  }

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withRouter(Settlement)));